import React, { useState } from "react";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill } from "../components/tag/Primitives";
import { api } from "../lib/api";
import { COMPANY, SUPPORT_EMAIL } from "../data/legal";

const TOPICS = [
  "General question",
  "Authority Audit ($99)",
  "Authority Blueprint ($497)",
  "Launch Kit",
  "AuthorityOS Build",
  "Press / media",
  "Partnership",
  "Legal / Privacy",
  "Other",
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", topic: TOPICS[0], message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Please enter your name.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return toast.error("Please enter a valid email.");
    if (!form.message.trim()) return toast.error("Please enter a message.");
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      setDone(true);
    } catch {
      toast.error("Could not send. Please try again or email " + SUPPORT_EMAIL);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout title={`Contact | ${COMPANY}`} path="/contact">
      <section style={{ background: "#090909", padding: "70px 32px 40px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 720, margin: "0 auto" }}>
          <div style={{ marginBottom: 22 }}><EyebrowPill>Get in Touch</EyebrowPill></div>
          <h1 className="tag-h1" style={{ marginBottom: 14 }}>Contact</h1>
          <p style={{ color: "#aaa", fontSize: 15, lineHeight: 1.6 }}>
            Questions, partnership ideas, or press? Send us a note. For policy questions, email{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "#FF6575" }}>{SUPPORT_EMAIL}</a>.
          </p>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "44px 20px 80px" }}>
        <div className="tag-card" data-testid="contact-card" style={{ maxWidth: 560, margin: "0 auto", padding: 32 }}>
          {!done ? (
            <form onSubmit={submit}>
              <Field label="Your name">
                <input
                  data-testid="contact-name"
                  className="tag-input"
                  value={form.name}
                  onChange={(e) => set("name", e.target.value)}
                  placeholder="Alex Doe"
                />
              </Field>
              <Field label="Email">
                <input
                  data-testid="contact-email"
                  type="email"
                  className="tag-input"
                  value={form.email}
                  onChange={(e) => set("email", e.target.value)}
                  placeholder="you@example.com"
                />
              </Field>
              <Field label="Topic">
                <select
                  data-testid="contact-topic"
                  className="tag-input"
                  value={form.topic}
                  onChange={(e) => set("topic", e.target.value)}
                  style={{ cursor: "pointer" }}
                >
                  {TOPICS.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </Field>
              <Field label="Message">
                <textarea
                  data-testid="contact-message"
                  rows={5}
                  className="tag-input"
                  value={form.message}
                  onChange={(e) => set("message", e.target.value)}
                  placeholder="What can we help with?"
                  style={{ resize: "vertical", minHeight: 120, fontFamily: "var(--font-body)" }}
                />
              </Field>
              <button
                data-testid="contact-submit"
                type="submit"
                className="btn-primary"
                disabled={submitting}
                style={{ width: "100%" }}
              >
                {submitting ? "Sending…" : "Send message"}
              </button>
              <p style={{ color: "#777", fontSize: 11, marginTop: 12, textAlign: "center" }}>
                We aim to respond within five (5) business days.
              </p>
            </form>
          ) : (
            <div data-testid="contact-success" style={{ textAlign: "center", padding: "20px 0" }}>
              <div style={{ color: "#FF6575", fontSize: 48, marginBottom: 8 }}>✓</div>
              <h2 className="tag-h2" style={{ marginBottom: 8 }}>Message sent.</h2>
              <p style={{ color: "#bbb", fontSize: 13 }}>We'll be in touch within five (5) business days.</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ display: "block", color: "#888", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>
      {label}
    </label>
    {children}
  </div>
);
